import dtm from 'scripts/services/dtm';

export function sendPhotoGallerySwipeAnalitycs(
    galleryName,
    photoId,
    photoCaption,
    photoNumber,
) {
    if (!galleryName || !photoId || !photoCaption || !photoNumber) {
        return;
    }

    dtm.trackPhotoGallerySwipe(galleryName, photoId, photoCaption, photoNumber);
}
